function SearchPage(){return/*#__PURE__*/React.createElement("div",{id:"search-pg"},"Search Page");}export default SearchPage;